import React from "react";
import { useLocation } from "react-router-dom";
import LoginButton from "./LoginButton";
const LoginForm = ({ onChange, onSubmit, form }) => {
  const location = useLocation();
  const error = location?.state?.error;
  return (
    <form onSubmit={onSubmit}>
      <div className="flex justify-center mb-4">
        <input
          type="text"
          className="w-full max-w-md py-2 px-4 rounded-lg outline-none"
          placeholder="Documento de identidad"
          name="docIdentidad"
          value={form.docIdentidad}
          onChange={onChange}
        />
      </div>
      <div className="flex justify-center mb-6">
        <input
          type="password"
          className="w-full max-w-md py-2 px-4 rounded-lg outline-none"
          placeholder="Clave"
          name="clave"
          value={form.clave}
          onChange={onChange}
        />
      </div>
      {error ? (
        <div className="flex justify-center mb-6">
          <div className="w-full max-w-md py-4 px-6 shadow-2xl shadow-red-800 rounded-lg bg-red-600">
            <div className="flex flex-col">
              <p className="text-white">{error}</p>
            </div>
          </div>
        </div>
      ) : null}
      <div className="w-full max-w-md mx-auto">
        <LoginButton />
      </div>
    </form>
  );
};
export default LoginForm;